import React, { lazy, Suspense, useEffect, useState } from "react";
import { Container, Row, Col, Image, Navbar, Nav } from "react-bootstrap";
import "./banner.css";
import htmlParser from "html-react-parser";
import Header from "../Header/index";


export default function Banner({ bannerData, loanOfficer, loInformation }) {
  const [navbar, setNavbar] = useState(false);
  const imgURL = process.env.REACT_APP_CDN_URL;
  //logo scroll when active

  const changeBackground = () => {
    if (window.scrollY >= 66) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  useEffect(() => {
    changeBackground();
    // adding the event when scroll change background
    window.addEventListener("scroll", changeBackground);
  });

  return (
    <>
      <div className="bannerbg">
        <Header />
        <Container className="pt-3">
          {/* <Navbar
            expand="lg"
            fixed="top"
            variant="dark"
            className={navbar ? "navbar active" : "navbar"}
            id="navbar"
          >
            <Container>
              <Navbar.Brand
                href="https://www.swmc.com"
                target="_blank"
                rel="noreferrer noopener"
                className="a-link"
              >
                <img
                  src={process.env.REACT_APP_CDN_LINK + "swmc-images/sunwest-trust-white-logo.png"}
                  alt="Sun West Logo"
                  className="swmclogo"
                />
              </Navbar.Brand>
            </Container>
          </Navbar> */}
          <Row>
            <Col sm={12} md={12} lg={6} xl={6} className="jotHeadingcol">
              
              <p className="jotheading">
                
              {htmlParser(bannerData.bannerHeading)}
              </p>
              <p className="text-center jotheadingmob">
              {htmlParser(bannerData.bannermobHeading)}
              </p>

              <h4 className="jotSubheading1">
              {htmlParser(bannerData.bannerSubHeading1)}
              </h4>
              <img 
              src={imgURL + "vector-1.webp"}
              className="Vector1"
              width="250"/>

            </Col>
            <Col>
            <img
            src={imgURL + "bannerlogo-desktop.webp"} 
            className="BannerLogo"
            // width={"400"}
            // style={{marginTop: "2rem", marginBottom: "5rem",marginLeft: "1rem"}} 
            />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
